import { ArraySchema, MapSchema } from "@colyseus/schema";
import { GAME_STATES } from "constants/constants";

const testRoomState = {

    pointlessData: {
        gameState: GAME_STATES.LOADING,
        
        timerRunning: true,
        timer: 34,
        finalAnswersLeft: 1,
        finalRoundTeamOrder: new ArraySchema(...[2]),
        finalRoundWin: true,
        category: "Entertainment",
        finalCategories: ["Entertainment", "Sports"],
        questions: new ArraySchema(
            {
                id: 1,
                question: "Employees at Vocala",
                answers: new ArraySchema(
                    {
                        id: 101,
                        points: 99,
                        answer: "Scott",
                        answered: true
                    },
                    {
                        id: 102,
                        points: 0,
                        answer: "Matt Sijbers",
                        answered: false,
                        reveal: true
                    },
                    {
                        id: 1,
                        points: 0,
                        answer: "Matt Smitd asdsa dad ad sd a dasd fsdf  asdfa sdfSh",
                        answered: false,
                        reveal: true
                    },
                    {
                        id: 104,
                        points: 100,
                        answer: "Rich",
                        answered: false,
                        reveal: true
                    },
                    {
                        id: 105,
                        points: 50,
                        answer: "Rob",
                        answered: false,
                        reveal: true
                    }
                ),
                answered: true
            },
            {
                id: 2,
                question: "Employees at Vocalsd adasas dad as",
                answers: new ArraySchema(
                    {
                        id: 101,
                        points: 99,
                        answer: "HARRY POTT",
                        answered: true
                    },
                    {
                        id: 102,
                        points: 0,
                        answer: "Matt Sijbers",
                        answered: false
                    },
                    {
                        id: 103,
                        points: 11,
                        answer: "Matt Smith",
                        answered: false
                    },
                    {
                        id: 104,
                        points: 100,
                        answer: "Rich",
                        answered: false
                    },
                    {
                        id: 105,
                        points: 50,
                        answer: "Rob",
                        answered: false
                    }
                ),
                answered: true
            },
            {
                id: 3,
                question: "Employees at Vocalasd asd as asda",
                answers: new ArraySchema(
                    {
                        id: 101,
                        points: 99,
                        answer: "massachusetts",
                        answered: true
                    },
                    {
                        id: 102,
                        points: 0,
                        answer: "Matt Sijbers",
                        answered: false
                    },
                    {
                        id: 1,
                        points: 11,
                        answer: "Matt Smith",
                        answered: false
                    },
                    {
                        id: 104,
                        points: 100,
                        answer: "Rich",
                        answered: false
                    },
                    {
                        id: 105,
                        points: 50,
                        answer: "Rob",
                        answered: false
                    }
                ),
                answered: true
            }
        ),
        questionType: "_FINAL",
        questionExplanation: "We are going to give you 7 fishy clues. We want you to tell us the fish described by the clue that you think the least of our 100 people knew. ",
        roundNumber: 4,
        activeTeamIndex: 1,
        teamCorrect: true,
       
        teams: new ArraySchema(
            {
                id: 0,
                memberIds: ["1", "2"],
                score: 0,
                active: true,
                colour: "#35A8E0",
                answer: ""
            },
            {
                id: 1,
                memberIds: ["3", "4"],
                score: 0,
                active: true,
                colour: "#93C01F",
                answer: "Tom Jones and Cerys Mathews",
                answerId: 1,
                answeredQuestionId: 1
            },
            {
                id: 2,
                memberIds: ["5", "6"],
                score: 0,
                active: false,
                colour: "#FA9600",
                answer: ""
            },
            {
                id: 3,
                memberIds: ["7", "8"],
                score: 0,
                active: false,
                colour: "#E40076",
                answer: ""
            }
        )
    },

    players: new MapSchema(
        {
            "1": {
                name: "WWWWWWWWWW",
                id: "1",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-0.png",
                primaryPlayer: true,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 0,
                    answer: "",
                    submitted: false
                }
            },
            "2": {
                name: "SCOTTY",
                id: "2",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-4.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 0,
                    answer: "",
                    submitted: false
                }
            },
            "3": {
                name: "RICH",
                id: "3",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-6.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 1,
                    answer: "",
                    submitted: false
                }
            },
            "4": {
                name: "ROB",
                id: "4",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-2.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 2,
                    answer: "",
                    submitted: false
                }
            },
            "5": {
                name: "MATTY",
                id: "5",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-10.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 2,
                    answer: "",
                    submitted: false
                }
            },
            "6": {
                name: "JOE",
                id: "6",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-7.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 2,
                    answer: "",
                    submitted: false
                }
            },
            "7": {
                name: "BRANDON",
                id: "7",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-8.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 3,
                    answer: "",
                    submitted: false
                }
            },
            "8": {
                name: "ADAM",
                id: "8",
                avatar: "https://gamecity.blob.core.windows.net/static-assets/avatars/avatar-9.png",
                primaryPlayer: false,
                connected: true,
                pointlessData: {
                    hasJoinedGame: true,
                    teamIndex: 3,
                    answer: "",
                    submitted: false
                }
            },
        },
    ),
}

export {
    testRoomState,
};